var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wizard-steps flex"},[_c('span',{staticClass:"line absolute"}),_vm._v(" "),_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,staticClass:"step",class:{
            activated: _vm.stepIsActivated(index),
            active: _vm.stepIsActive(step),
            disabled: _vm.stepIsDisabled(index)
        },attrs:{"id":`step-${index + 1}`},on:{"click":function($event){return _vm.next(step.name)}}},[_c('div',{staticClass:"inner-circle"}),_vm._v(" "),_c('div',{staticClass:"bullet"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('img',{attrs:{"src":"/img/done-white-18dp.svg","alt":""}})])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }